"use client";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import logo from "@/public/logo.svg";
import Image from "next/image";
import { Paragraph, Title } from "@/components/ui/typography";
import Link from "next/link";
import { X, ChartNoAxesColumnDecreasing } from "lucide-react";
import { useState } from "react";
import LangaugeDropDown from "./LangaugeDropDown";
import { paths } from "@/app/constant";

const menuList2 = [
  // { label: "About us", link: "/about" },
  { label: "Contact us", link: "", link: paths.contactUs },
  { label: "Services", link: paths.services },
];

const navItems = [
  {
    name: "Shop",
    href: "/",
  },
  {
    name: "iPads",
    href: "/",
  },
  {
    name: "Laptops",
    href: "/",
  },
  {
    name: "Smartphones",
    href: "/",
  },
  {
    name: "Accessories",
    subItem: [
      {
        name: "iPads",
        href: "/",
      },
      {
        name: "Laptops",
        href: "/",
      },
      {
        name: "Smartphones",
        href: "/",
      },
      {
        name: "Accessories",
        href: "/",
      },
    ],
  },
  {
    name: "Shop",
    href: "/",
  },
  {
    name: "iPads",
    href: "/",
  },
  {
    name: "Laptops",
    href: "/",
  },
  {
    name: "Smartphones",
    href: "/",
  },
  {
    name: "Accessories",
    subItem: [
      {
        name: "iPads",
        href: "/",
      },
      {
        name: "Laptops",
        href: "/",
      },
      {
        name: "Smartphones",
        href: "/",
      },
      {
        name: "Accessories",
        href: "/",
      },
    ],
  },
  {
    name: "Shop",
    href: "/",
  },
  {
    name: "iPads",
    href: "/",
  },
  {
    name: "Laptops",
    href: "/",
  },
  {
    name: "Smartphones",
    href: "/",
  },
  {
    name: "Accessories",
    subItem: [
      {
        name: "iPads",
        href: "/",
      },
      {
        name: "Laptops",
        href: "/",
      },
      {
        name: "Smartphones",
        href: "/",
      },
      {
        name: "Accessories",
        href: "/",
      },
    ],
  },
  {
    name: "Shop",
    href: "/",
  },
  {
    name: "iPads",
    href: "/",
  },
  {
    name: "Laptops",
    href: "/",
  },
  {
    name: "Smartphones",
    href: "/",
  },
  {
    name: "Accessories",
    subItem: [
      {
        name: "iPads",
        href: "/",
      },
      {
        name: "Laptops",
        href: "/",
      },
      {
        name: "Smartphones",
        href: "/",
      },
      {
        name: "Accessories",
        href: "/",
      },
    ],
  },
];

const MenuItem = ({ item }) => {
  if (item?.subItem) {
    return (
      <Accordion type="single" collapsible>
        <AccordionItem value="item-1">
          <AccordionTrigger className="border-0 outline-0">
            <Title as="li" size="xs">
              {item.name}
            </Title>
          </AccordionTrigger>
          <AccordionContent>
            <ul>
              {item.subItem.map((item, index) => (
                <Paragraph
                  key={index}
                  as="li"
                  size="xs"
                  className="py-2 cursor-pointer"
                  onClick={() => (window.location.href = item.href)}
                >
                  <span>{item.name}</span>
                </Paragraph>
              ))}
            </ul>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  } else {
    return (
      <Title
        as="li"
        size="xs"
        className="py-4 border-b cursor-pointer"
        onClick={() => (window.location.href = item.href)}
      >
        <span>{item.name}</span>
      </Title>
    );
  }
};

export default function MobileMenu({ categoryList }) {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger className="relative" asChild>
        <ChartNoAxesColumnDecreasing className="rotate-90 " />
      </SheetTrigger>
      <SheetContent
        onInteractOutside={(e) => e.preventDefault()}
        position={"right"}
        hideClose
        side={"left"}
        className="w-[332px] lg:hidden !max-w-[332px] mx-auto p-0 overflow-y-auto z-50"
      >
        <nav>
          <header className="h-[74px] border borber-b sticky flex justify-between items-center top-0 bg-white p-4">
            <Image src={logo} width={118} height={26} alt="wwws logo" />
            <div className="flex gap-2">
              <div className="block md:hidden">
                <LangaugeDropDown />
              </div>
              <X onClick={() => setOpen(false)} />
            </div>
          </header>
          <div>
            <ul className="px-4">
              <MenuItem item={{ name: "Shop", href: "/products" }}></MenuItem>
            </ul>
            {categoryList?.categories?.map((item, index) => {
              if (item?.ordering_number && item?.ordering_number <= 5) {
                return (
                  <ul key={index} className="px-4">
                    <MenuItem
                      item={{
                        name: item.category_name,
                        href: `/products?Category=${item.category_name}`,
                      }}
                    ></MenuItem>
                  </ul>
                );
              } else return null;
            })}
            {/* <ul className="px-4">
              {navItems.map((item) => (
                <MenuItem key={item.name} item={item} />
              ))}
            </ul> */}
            {menuList2.map((item, index) => (
              <ul key={item + index} className="px-4">
                <MenuItem
                  item={{ name: item.label, href: item.link }}
                ></MenuItem>
              </ul>
            ))}
          </div>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
